// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"30c7b65c","453":"70b4b260"}[chunkId] + ".chunk.js";
};